export default __webpack_public_path__ + "static/media/Success.89b9312e.png";